// Defensive sanitiser for internal-user full_name values displayed on
// supplier-facing surfaces. If a row ever stores a trailing ", Title"
// suffix (legacy data shape), strip it before it surfaces to suppliers.
// Schema today keeps name + job_title in separate columns so this is
// belt-and-braces — but the name-only rule on supplier-facing surfaces
// is absolute (no role/title surfaces alongside a PM name), so we filter
// at the seam.
//
// Regex matches ", " followed by a Title-Cased word run of 3+ chars at
// end-of-string, so legitimate names like "Smith, Jr" are left alone
// (too short to match). Returns the cleaned name, or '' when input is
// falsy — callers can treat empty as "no usable name on file" and fall
// back to the no-PM copy variant.
export const extractName = (fullName) => {
  if (!fullName) return '';
  return String(fullName).replace(/, [A-Z][a-zA-Z ]{2,}$/, '').trim();
};
